import { Injectable } from '@angular/core';
import {DataService} from '../data.service';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ReportsService extends DataService {

  private carrierReportsURI = this.publicApiUri + '/hhg3080survey/generateTspSurveyReport/';
  private surveyReportsURI = this.publicApiUri + '/hhg3080survey/generateSurveyReport/';
  private amcReportsURI =  this.publicApiUri + '/hhg3080survey/generateAmcSurveyReport/';
  private agencyBureauURI = this.publicApiUri + '/hhg3080survey/getAgencyBureau/';
  private adminURI = this.publicApiUri + '/hhg3080survey/generateEvaluationSurveyReport/';
  private adminWithYearURI = this.publicApiUri + '/hhg3080survey/generateEvaluationSurveyReportWithYear/';
  private amcReportsWithYearURI =  this.publicApiUri + '/hhg3080survey/generateAmcSurveyReportWithYear/';
  constructor(http: HttpClient) {
    super(http);
  }
  getCarrierReports(carrierId) {
    return this.http.get(this.carrierReportsURI + carrierId);
  }
  getCarrierReportsWithYear(carrierId, year) {
    return this.http.get(this.carrierReportsURI + carrierId + "/carrier/" + year + "/year");
  }
  getSurveyReport(year) {
    return this.http.get(this.surveyReportsURI + year);
  }
  getAmcReports(agencyBureauCode) {
    return this.http.get(this.amcReportsURI + agencyBureauCode);
  }
  getAmcReportsWithYear(agencyBureauCode, year) {
    return this.http.get(this.amcReportsWithYearURI + agencyBureauCode + "/"+year);
  }
  getAdminReports() {
    return this.http.get(this.adminURI);
  }
  getAdminReportsWithYear(year) {
    return this.http.get(this.adminWithYearURI + year);
  }
  getAgencyBureauCode(userId) {
    return this.http.get(this.agencyBureauURI + userId, {responseType: 'text' as 'json'});
  }
}
